import { render, staticRenderFns } from "./CheckboxControl.vue?vue&type=template&id=67c15e50&scoped=true&"
import script from "./CheckboxControl.vue?vue&type=script&lang=ts&"
export * from "./CheckboxControl.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxControl.vue?vue&type=style&index=0&id=67c15e50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c15e50",
  null
  
)

export default component.exports